import { assert, type Equals } from 'tsafe'

import type supportedLanguages from './config/languages.json'
import cn from './data/cn.json'
import de from './data/de.json'
import en from './data/en.json'
import es from './data/es.json'
import fr from './data/fr.json'
import it from './data/it.json'
import ja from './data/ja.json'
import ko from './data/ko.json'
import nl from './data/nl.json'
import pl from './data/pl.json'
import pt from './data/pt.json'
import ru from './data/ru.json'
import tr from './data/tr.json'
import tw from './data/tw.json'

const translationsSourceJSON = { cn, de, en, es, fr, it, ja, ko, nl, pl, pt, ru, tr, tw }

export const translations = translationsSourceJSON

type LanguageImported = keyof typeof translations
type LanguageSupported = keyof typeof supportedLanguages

// NOTE: Ensure that all languages from languages.json are imported
assert<Equals<LanguageImported, LanguageSupported>>()
